/* eslint-disable no-unused-vars */
import React from 'react';
/* eslint-enable no-unused-vars */

const getFormConfig = () => {
  return {
    connectWithUs: [
      {
        name: 'firstname',
        title: 'RequestThisEmployee.Form.FirstName',
        type: 'text',
      },
      {
        name: 'lastname',
        title: 'RequestThisEmployee.Form.LastName',
        type: 'text',
      },
      {
        name: 'email',
        title: 'RequestThisEmployee.Form.Email',
        type: 'email',
      },
      {
        name: 'company',
        title: 'RequestThisEmployee.Form.CompanyName',
        type: 'text',
      },
      {
        name: 'phone',
        title: 'RequestThisEmployee.Form.PhoneNumber',
        type: 'phone',
      },
      {
        name: 'all_industries_select_your_industry',
        title: 'RequestThisEmployee.Form.AreaOfSpecialization',
        type: 'pick',
        options: [
          {
            value: '',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.ChooseSpecialization',
            isTranslation: true,
          },
          {
            value: 'engineering',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.Engineering',
            isTranslation: true,
          },
          {
            value: 'finance and accounting',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.FinanceAccounting',
            isTranslation: true,
          },
          {
            value: 'healthcare',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.Healthcare',
            isTranslation: true,
          },
          {
            value: 'HR',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.HR',
            isTranslation: true,
          },
          {
            value: 'IT',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.IT',
            isTranslation: true,
          },
          {
            value: 'legal',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.Legal',
            isTranslation: true,
          },
          {
            value: 'life sciences',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.LifeSciences',
            isTranslation: true,
          },
          {
            value: 'manufacturing and logistics',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.ManufacturingLogistics',
            isTranslation: true,
          },
          {
            value: 'marketing',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.Marketing',
            isTranslation: true,
          },
          {
            value: 'non-clinical healthcare',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.NonClinicalHealthcare',
            isTranslation: true,
          },
          {
            value: 'office and administration',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.OfficeAdministration',
            isTranslation: true,
          },
        ],
      },
      {
        name: 'jobtitle',
        title: 'RequestThisEmployee.Form.JobRole',
        type: 'pick',
        options: [
          {
            value: '',
            label: 'RequestThisEmployee.Form.JobRole.Options.ChooseSpecialization',
            isTranslation: true,
          },
          {
            value: 'business owner/leader',
            label: 'RequestThisEmployee.Form.JobRole.Options.BusinessLeader',
            isTranslation: true,
          },
          {
            value: 'head of department (HR/talent)',
            label: 'RequestThisEmployee.Form.JobRole.Options.HeadOfDepartmentHr',
            isTranslation: true,
          },
          {
            value: 'head of department (other)',
            label: 'RequestThisEmployee.Form.JobRole.Options.HeadOfDepartmentOther',
            isTranslation: true,
          },
          {
            value: 'director (HR/talent)',
            label: 'RequestThisEmployee.Form.JobRole.Options.DirectorHR',
            isTranslation: true,
          },
          {
            value: 'director (other)',
            label: 'RequestThisEmployee.Form.JobRole.Options.DirectorOther',
            isTranslation: true,
          },
          {
            value: 'manager (HR/talent)',
            label: 'RequestThisEmployee.Form.JobRole.Options.ManagerHr',
            isTranslation: true,
          },
          {
            value: 'manager (other)',
            label: 'RequestThisEmployee.Form.JobRole.Options.ManagerOther',
            isTranslation: true,
          },
          {
            value: 'social media manager',
            label: 'RequestThisEmployee.Form.JobRole.Options.SocialMediaManager',
            isTranslation: true,
          },
          {
            value: 'recruiter/sourcer',
            label: 'RequestThisEmployee.Form.JobRole.Options.Recruiter',
            isTranslation: true,
          },
          {
            value: 'student/intern',
            label: 'RequestThisEmployee.Form.JobRole.Options.Student',
            isTranslation: true,
          },
          {
            value: 'job seeker',
            label: 'RequestThisEmployee.Form.JobRole.Options.JobSeeker',
            isTranslation: true,
          },
          {
            value: 'other',
            label: 'RequestThisEmployee.Form.JobRole.Options.Other',
            isTranslation: true,
          },
        ],
      },
      {
        name: 'zip',
        title: 'RequestThisEmployee.Form.Location',
        type: 'text',
      },
      {
        name: 'candidate_location_browse_talent',
        title: 'Subscribe.Form.Location',
        type: 'text',
        placeholder: 'Subscribe.Form.Location.Placeholder',
        required: false,
      },
      {
        name: 'tell_us_more',
        title: 'ConnectWithUs.Form.Notes',
        type: 'textarea',
        placeholder: 'RequestThisEmployee.Form.Notes.Placeholder',
        required: false,
      },
      {
        name: 'email_alert',
        type: 'checkbox',
        title: 'RequestThisEmployee.Form.EmailAlert.Label',
      },
    ],
    requestEmployee: [
      {
        name: 'firstname',
        title: 'RequestThisEmployee.Form.FirstName',
        type: 'text',
      },
      {
        name: 'lastname',
        title: 'RequestThisEmployee.Form.LastName',
        type: 'text',
      },
      {
        name: 'email',
        title: 'RequestThisEmployee.Form.Email',
        type: 'email',
      },
      {
        name: 'company',
        title: 'RequestThisEmployee.Form.CompanyName',
        type: 'text',
      },
      {
        name: 'phone',
        title: 'RequestThisEmployee.Form.PhoneNumber',
        type: 'phone',
      },
      {
        name: 'all_industries_select_your_industry',
        title: 'RequestThisEmployee.Form.AreaOfSpecialization',
        type: 'pick',
        options: [
          {
            value: '',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.ChooseSpecialization',
            isTranslation: true,
          },
          {
            value: 'engineering',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.Engineering',
            isTranslation: true,
          },
          {
            value: 'finance and accounting',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.FinanceAccounting',
            isTranslation: true,
          },
          {
            value: 'healthcare',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.Healthcare',
            isTranslation: true,
          },
          {
            value: 'HR',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.HR',
            isTranslation: true,
          },
          {
            value: 'IT',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.IT',
            isTranslation: true,
          },
          {
            value: 'legal',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.Legal',
            isTranslation: true,
          },
          {
            value: 'life sciences',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.LifeSciences',
            isTranslation: true,
          },
          {
            value: 'manufacturing and logistics',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.ManufacturingLogistics',
            isTranslation: true,
          },
          {
            value: 'marketing',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.Marketing',
            isTranslation: true,
          },
          {
            value: 'non-clinical healthcare',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.NonClinicalHealthcare',
            isTranslation: true,
          },
          {
            value: 'office and administration',
            label: 'RequestThisEmployee.Form.AreaOfSpecialization.Options.OfficeAdministration',
            isTranslation: true,
          },
        ],
      },
      {
        name: 'jobtitle',
        title: 'RequestThisEmployee.Form.JobRole',
        type: 'pick',
        options: [
          {
            value: '',
            label: 'RequestThisEmployee.Form.JobRole.Options.ChooseSpecialization',
            isTranslation: true,
          },
          {
            value: 'business owner/leader',
            label: 'RequestThisEmployee.Form.JobRole.Options.BusinessLeader',
            isTranslation: true,
          },
          {
            value: 'head of department (HR/talent)',
            label: 'RequestThisEmployee.Form.JobRole.Options.HeadOfDepartmentHr',
            isTranslation: true,
          },
          {
            value: 'head of department (other)',
            label: 'RequestThisEmployee.Form.JobRole.Options.HeadOfDepartmentOther',
            isTranslation: true,
          },
          {
            value: 'director (HR/talent)',
            label: 'RequestThisEmployee.Form.JobRole.Options.DirectorHR',
            isTranslation: true,
          },
          {
            value: 'director (other)',
            label: 'RequestThisEmployee.Form.JobRole.Options.DirectorOther',
            isTranslation: true,
          },
          {
            value: 'manager (HR/talent)',
            label: 'RequestThisEmployee.Form.JobRole.Options.ManagerHr',
            isTranslation: true,
          },
          {
            value: 'manager (other)',
            label: 'RequestThisEmployee.Form.JobRole.Options.ManagerOther',
            isTranslation: true,
          },
          {
            value: 'social media manager',
            label: 'RequestThisEmployee.Form.JobRole.Options.SocialMediaManager',
            isTranslation: true,
          },
          {
            value: 'recruiter/sourcer',
            label: 'RequestThisEmployee.Form.JobRole.Options.Recruiter',
            isTranslation: true,
          },
          {
            value: 'student/intern',
            label: 'RequestThisEmployee.Form.JobRole.Options.Student',
            isTranslation: true,
          },
          {
            value: 'job seeker',
            label: 'RequestThisEmployee.Form.JobRole.Options.JobSeeker',
            isTranslation: true,
          },
          {
            value: 'other',
            label: 'RequestThisEmployee.Form.JobRole.Options.Other',
            isTranslation: true,
          },
        ],
      },
      {
        name: 'location',
        title: 'RequestThisEmployee.Form.Location',
        type: 'zipcode',
      },
      {
        name: 'tell_us_more',
        title: 'RequestThisEmployee.Form.Notes',
        type: 'textarea',
        placeholder: 'RequestThisEmployee.Form.Notes.Placeholder',
        required: false,
      },
      {
        name: 'email_alert',
        type: 'checkbox',
        title: 'RequestThisEmployee.Form.EmailAlert.Label',
      },
    ],
    subscribe_preference: [
      {
        name: 'job_title',
        title: 'Subscribe.Form.JobTitle',
        type: 'text',
        placeholder: 'Subscribe.Form.JobTitle.Placeholder',
      },
      {
        name: 'location',
        title: 'Subscribe.Form.Location',
        type: 'location',
        placeholder: 'Subscribe.Form.Location.Placeholder',
      },
    ],
    subscribe_details: [
      {
        name: 'email',
        title: 'Subscribe.Form.Email',
        type: 'email',
        placeholder: 'Subscribe.Form.Email.Placeholder',
      },
      {
        name: 'frequency',
        title: 'Subscribe.Form.Frequency',
        type: 'pick',
        placeholder: 'Subscribe.Form.Frequency.Placeholder',
        options: [
          {
            value: '',
            label: 'Subscribe.Form.Frequency.Options.SelectFrequency',
            isTranslation: true,
          },
          {
            value: 'daily',
            label: 'Subscribe.Form.Frequency.Options.Daily',
            isTranslation: true,
          },
          {
            value: 'weekly',
            label: 'Subscribe.Form.Frequency.Options.Weekly',
            isTranslation: true,
          },
          {
            value: 'biweekly',
            label: 'Subscribe.Form.Frequency.Options.BiWeekly',
            isTranslation: true,
          },
          {
            value: 'monthly',
            label: 'Subscribe.Form.Frequency.Options.Monthly',
            isTranslation: true,
          },
        ],
      },
    ],
    subscribe_modal: [
      {
        name: 'job_title',
        title: 'Subscribe.Form.JobTitle',
        type: 'text',
      },
      {
        name: 'location',
        title: 'Subscribe.Form.Location',
        type: 'location',
        placeholder: 'Subscribe.Form.Location.Placeholder',
      },
      {
        name: 'email',
        title: 'SubscribeFormModal.Email',
        type: 'email',
      },
      {
        name: 'frequency',
        title: 'Subscribe.Form.Frequency',
        type: 'pick',
        placeholder: 'Subscribe.Form.Frequency.Placeholder',
        options: [
          {
            value: '',
            label: 'Subscribe.Form.Frequency.Options.SelectFrequency',
            isTranslation: true,
          },
          {
            value: 'DAILY',
            label: 'Subscribe.Form.Frequency.Options.Daily',
            isTranslation: true,
          },
          {
            value: 'WEEKLY',
            label: 'Subscribe.Form.Frequency.Options.Weekly',
            isTranslation: true,
          },
          {
            value: 'BIWEEKLY',
            label: 'Subscribe.Form.Frequency.Options.BiWeekly',
            isTranslation: true,
          },
          {
            value: 'MONTHLY',
            label: 'Subscribe.Form.Frequency.Options.Monthly',
            isTranslation: true,
          },
        ],
      },
    ],
  };
};

export default getFormConfig;
